/** Zoom steps shared by every PDF viewer. 1 = the base page width. */
export const ZOOM_STEPS = [0.6, 0.8, 1, 1.25, 1.5, 2] as const;

export function ZoomControl({
  zoom,
  onChange,
}: {
  zoom: number;
  onChange: (zoom: number) => void;
}) {
  const index = Math.max(0, ZOOM_STEPS.findIndex((z) => z === zoom));
  const btn =
    'rounded-lg border border-slate-300 px-2.5 py-1.5 text-xs font-semibold text-slate-700 transition hover:bg-slate-50 disabled:opacity-40';
  return (
    <div className="flex items-center gap-1" role="group" aria-label="Zoom">
      <button type="button" aria-label="Zoom out" className={btn}
        disabled={index === 0}
        onClick={() => onChange(ZOOM_STEPS[Math.max(0, index - 1)]!)}>
        &minus;
      </button>
      <button type="button" aria-label="Reset zoom" className={`${btn} min-w-[3.25rem]`}
        onClick={() => onChange(1)}>
        {Math.round(zoom * 100)}%
      </button>
      <button type="button" aria-label="Zoom in" className={btn}
        disabled={index === ZOOM_STEPS.length - 1}
        onClick={() => onChange(ZOOM_STEPS[Math.min(ZOOM_STEPS.length - 1, index + 1)]!)}>
        +
      </button>
    </div>
  );
}
